import { PhExceptionErrorType } from '@core/enums/ph-exception-error-type.enum';

export const OrderSubmissionErrorTypes: PhExceptionErrorType[] = [
  PhExceptionErrorType.OrderSubmitTransactionFailedException,
  PhExceptionErrorType.OrderSubmitCvvDoesNotMatchException,
  PhExceptionErrorType.OrderSubmitZipDoesNotMatchException,
  PhExceptionErrorType.PipelineException,
];
